import React from "react";
import { FacebookIcon } from "@thrivetribe/mvf.assets.icons.facebook-icon";
import { InstagramIcon } from "@thrivetribe/mvf.assets.icons.instagram-icon";
import { TwitterIcon } from "@thrivetribe/mvf.assets.icons.twitter-icon";
import { facebookLink, instagramLink, twitterLink } from "configs/UrlConfig";

export const SidebarSocialMedia: React.FC = () => {
  return (
    <div className="sidebar__social-media-links">
      <a href={facebookLink.url} target={facebookLink.target}>
        <FacebookIcon />
      </a>
      <a href={instagramLink.url} target={instagramLink.target}>
        <InstagramIcon />
      </a>
      <a href={twitterLink.url} target={twitterLink.target}>
        <TwitterIcon />
      </a>
    </div>
  );
};
